import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import { createTransformer } from '../core';
// TODO: Make a package for utilitys like this one
var selectInnerMostBreadcrumbName = function selectInnerMostBreadcrumbName(breadcrumbs) {
  var NO_BREADCRUMB_FOUND_NAME = 'none';
  if (breadcrumbs.length <= 0) {
    return NO_BREADCRUMB_FOUND_NAME;
  }
  return breadcrumbs[breadcrumbs.length - 1].name.toString();
};
var breadcrumbsToAttributes = function breadcrumbsToAttributes(breadcrumbs) {
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(breadcrumbs.map(function (breadcrumb) {
    var _breadcrumb$attribute;
    return (_breadcrumb$attribute = breadcrumb.attributes) !== null && _breadcrumb$attribute !== void 0 ? _breadcrumb$attribute : {};
  }))));
};
export var getTelemetryGasV3SharedInfo = function getTelemetryGasV3SharedInfo(_ref) {
  var breadcrumbs = _ref.breadcrumbs;
  var source = selectInnerMostBreadcrumbName(breadcrumbs);
  var attributes = breadcrumbsToAttributes(breadcrumbs);

  // TODO: Remove the as cast
  return {
    attributes: attributes,
    source: source
  };
};
export var createGasV3EventTransformer = function createGasV3EventTransformer(_ref2) {
  var from = _ref2.from,
    to = _ref2.to,
    useTransformer = _ref2.useTransformer;
  // Gotta be outside the scope otherwise hooks will keep recomputing
  var useGasV3Transformer = function useGasV3Transformer(transformProps) {
    var transform = useTransformer(transformProps);
    return useCallback(function (_ref3) {
      var breadcrumbs = _ref3.breadcrumbs,
        originalPayload = _ref3.payload;
      var source = selectInnerMostBreadcrumbName(breadcrumbs);
      var breadcrumbAttributes = breadcrumbsToAttributes(breadcrumbs);
      var newPartialPayload = transform(originalPayload);
      // TODO: Remove the as cast
      return _objectSpread(_objectSpread({}, newPartialPayload), {}, {
        attributes: _objectSpread(_objectSpread({}, breadcrumbAttributes), newPartialPayload.attributes),
        source: source
      });
    }, [transform]);
  };
  var ArbitraryEventToConnectedEvent = createTransformer({
    from: from,
    to: to,
    useTransformer: useGasV3Transformer
  });
  return ArbitraryEventToConnectedEvent;
};
export var createGasV3UIEventTransformer = createGasV3EventTransformer;
export var createGasV3TrackEventTransformer = createGasV3EventTransformer;
export var createGasV3OperationalEventTransformer = createGasV3EventTransformer;
export var breadcrumbMountedPayloadToGasV3ScreenEvent = function breadcrumbMountedPayloadToGasV3ScreenEvent(_ref4) {
  var breadcrumbs = _ref4.breadcrumbs;
  var name = selectInnerMostBreadcrumbName(breadcrumbs);
  var attributes = breadcrumbsToAttributes(breadcrumbs);
  return {
    name: name,
    attributes: attributes
  };
};
export var createGasV3ScreenEventTransformer = function createGasV3ScreenEventTransformer(_ref5) {
  var to = _ref5.to,
    breadcrumbMountedEventChannel = _ref5.breadcrumbAPI.breadcrumbMountedEventChannel;
  var BreadcrumbRenderedToScreenEvent = createTransformer({
    from: breadcrumbMountedEventChannel.Listener,
    to: to,
    useTransformer: function useTransformer() {
      return breadcrumbMountedPayloadToGasV3ScreenEvent;
    }
  });
  return BreadcrumbRenderedToScreenEvent;
};